import { render, staticRenderFns } from "./limit-editor.vue?vue&type=template&id=5d0ec6b2&scoped=true&"
import script from "./limit-editor.vue?vue&type=script&lang=js&"
export * from "./limit-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ec6b2",
  null
  
)

export default component.exports